if (!customElements.get('product-size-guide')) {
  customElements.define(
    'product-size-guide',
    class ProductSizeGuide extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.dialog = this.querySelector('.product-size-guide__dialog');
        this.trigger = this.querySelector('.product-size-guide__trigger');
        this.closeButton = this.querySelector('.product-size-guide__close');

        if (!this.dialog || !this.trigger || !this.closeButton) return;

        this.initialized = true;
        this.trigger.addEventListener('click', () => this.open());
        this.closeButton.addEventListener('click', () => this.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('close', () => this.unlockPage());
        this.dialog.addEventListener('cancel', () => this.unlockPage());
      }

      disconnectedCallback() {
        this.unlockPage();
      }

      open() {
        if (this.dialog.open) return;

        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }

        document.documentElement.classList.add('product-size-guide-is-open');
        document.body.classList.add('product-size-guide-is-open');
      }

      close() {
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          this.unlockPage();
        }
      }

      unlockPage() {
        if (document.querySelector('.product-size-guide__dialog[open]')) return;

        document.documentElement.classList.remove('product-size-guide-is-open');
        document.body.classList.remove('product-size-guide-is-open');
      }
    }
  );
}
